import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { Grid2 } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Actions } from "../../../../../../redux/constants/actionTypes";
import { getStore } from "../../../../../../Utils/storeUtils";
import { useMakeApiCalls } from "../../../../../../Hooks/useMakeApiCalls";
//styles
import styles from "./ClientOrgStyles.module.scss";
//icons
import { ReactComponent as SiteIcon } from "../../../../AdminAssets/svg/site.svg";
import { ReactComponent as MemberIcon } from "../../../../AdminAssets/svg/members.svg";
import { getColorPairForName } from "../../../../../../Utils/utils";
import PageLoading from "../../../../../../GlobalComponents/PageLoading/PageLoading";
import { ReactComponent as ClientOrgImage } from "../../../../AdminAssets/svg/ClientOrganization.svg";
import {
  EmptyStateForCilentOrg,
  formatFileSize,
  lastSegmentPath,
  NewEmptyStateForCilentOrg,
} from "../../../../../../Utils/roconConstants";
import EmptyState from "../../../../../../GlobalComponents/EmptyState/EmptyState";
import NewEmptyState from "../../../../../../GlobalComponents/EmptyState/NewEmptyState";
import PlanExpiredCard from "../../../../../../GlobalComponents/PlanExpiredCard/PlanExpiredCard";
import FormPopup from "../../../../../../GlobalComponents/FormPopup/FormPopup";

function ClientOrganizations() {
  const navigate = useNavigate();

  const [popup, setPopup] = useState({
    popupState: false,
    popupType: "",
    popupTitle: "",
    popupSubtitle: "",
    popupSubtitle1: "",
    popupButton: false,
    popupCancel: false,
    popupButtonTitle: "",
    popupButtonFunction: () => {},
    popupCancelTitle: "",
    popupCancelFunction: () => {},
  });

  const ActivatePopup = (type, message, onConfirm) => {
    if (type === "warning") {
      setPopup({
        popupState: true,
        popupType: "warning",
        popupTitle: message,
        popupButton: true,
        popupButtonTitle: "Ok",
        popupButtonFunction: () => {
          setPopup({ popupState: false });
          if (onConfirm) onConfirm();
        },
      });
    } else if (type === "none") {
      setPopup({ popupState: false });
    }
  };

  const params = useParams();
  const orgId = params.orgId;

  const location = useLocation();
  const lastSegment = lastSegmentPath(location);

  const specificPlan = useSelector(
    (state) => state.plansInfo?.specificPlan?.specificPlans,
  );

  const basePlan = specificPlan?.find((item) => item.basePlan === true) || {};
  const cancel = basePlan?.cancel;
  const daysAfterExpiry = basePlan?.daysAfterExpiry;
  const selectedOrg = useSelector(
    (state) => state.organizationsInfo?.selectedOrg,
  );

  useMakeApiCalls(() => {
    getStore().dispatch({
      type: Actions.API_GET_SELECTED_ORG_FULL_INFO,
      orgId: orgId,
    });
    getStore().dispatch({
      type: Actions.SET_ORG_DETAILS,
      data: {
        orgId: orgId,
        orgPage: lastSegment,
      },
    });
    getStore().dispatch({ type: Actions.API_ORG_DASHBOARD });
  });

  useEffect(() => {
    getStore().dispatch({
      type: Actions.API_GET_SEPCIFIC_PLAN,
      data: { orgId: orgId },
    });
  }, [orgId]);

  const orgName = useSelector(
    (state) => state?.organizationsInfo?.selectedOrg?.name,
  );

  useEffect(() => {
    if (orgName)
      getStore().dispatch({
        type: Actions.API_FETCH_CHILD_ORGS,
        data: { orgName: orgName },
      });
  }, [orgName]);

  const childOrgs = useSelector(
    (state) => state.organizationsInfo?.childOrgs?.data,
  );

  const allOrgs = useSelector(
    (state) => state.organizationsInfo?.dashboardOrg?.data,
  );

  const handleClientClick = (org) => {
    const existsInAllOrgs = allOrgs?.some(
      (existingOrg) => existingOrg.orgId === org.orgId,
    );
    if (!existsInAllOrgs) {
      ActivatePopup(
        "warning",
        "You don't have access to this organization. Please contact your admin.",
      );
      return;
    }
    navigate(`/account/${org.orgId}/dashboard`);
  };

  return (
    <>
      {childOrgs ? (
        <>
          {specificPlan?.length > 0 ? (
            <Grid2 container direction="column">
              {childOrgs?.length > 0 ? (
                <>
                  <Grid2 className={styles.label}>Client Organizations</Grid2>
                  {childOrgs?.map((org, index) => (
                    <Grid2
                      key={index}
                      className={styles.clientContainer}
                      onClick={() => handleClientClick(org)}
                    >
                      <Grid2 className={styles.center}>
                        <Grid2
                          className={styles.orgShortName}
                          style={{
                            backgroundColor: getColorPairForName(org.orgName)
                              .light,
                            color: getColorPairForName(org.orgName).dark,
                          }}
                        >
                          {org.orgName && org.orgName.charAt(0).toUpperCase()}
                        </Grid2>
                        <Grid2 className={styles.color}>
                          {org.orgName || `Organization ${index + 1}`}
                        </Grid2>
                      </Grid2>
                      <Grid2 className={styles.center}>
                        <Grid2 className={styles.icon}>
                          <SiteIcon />
                        </Grid2>
                        <Grid2 className={styles.color}>
                          {org.numOfSites || 0} Sites
                        </Grid2>
                      </Grid2>
                      <Grid2 className={styles.center}>
                        <Grid2 className={styles.icon}>
                          <MemberIcon />
                        </Grid2>
                        <Grid2 className={styles.color}>
                          {org.numOfOrgMembers || 0} Members
                        </Grid2>
                      </Grid2>
                      <Grid2 className={styles.stats}>
                        <Grid2 className={styles.stats1}>
                          <Grid2 className={styles.statsHeader}>
                            <Grid2 item className={styles.statsHead}>
                              <Grid2 className={styles.statsUsage}>
                                {formatFileSize(Number(org?.usedStorage))}
                              </Grid2>
                            </Grid2>
                            <Grid2 item className={styles.statsHead1}>
                              Storage
                            </Grid2>
                          </Grid2>
                        </Grid2>
                      </Grid2>
                      <Grid2 className={styles.stats}>
                        <Grid2 className={styles.stats1}>
                          <Grid2 className={styles.statsHeader}>
                            <Grid2 item className={styles.statsHead}>
                              <Grid2 className={styles.statsUsage}>
                                {formatFileSize(Number(org?.usedBandwidth))}
                              </Grid2>
                            </Grid2>
                            <Grid2 item className={styles.statsHead1}>
                              Bandwidth
                            </Grid2>
                          </Grid2>
                        </Grid2>
                      </Grid2>
                      <Grid2 className={styles.stats}>
                        <Grid2 className={styles.stats1}>
                          <Grid2 className={styles.statsHeader}>
                            <Grid2 item className={styles.statsHead}>
                              <Grid2 className={styles.statsUsage}>
                                {formatFileSize(Number(org?.usedVisits))}
                              </Grid2>
                            </Grid2>
                            <Grid2 item className={styles.statsHead1}>
                              Visits
                            </Grid2>
                          </Grid2>
                        </Grid2>
                      </Grid2>
                    </Grid2>
                  ))}
                </>
              ) : (
                <EmptyState
                  header={EmptyStateForCilentOrg.header}
                  subHeader={EmptyStateForCilentOrg.subHeader}
                  icon={ClientOrgImage}
                  title={EmptyStateForCilentOrg.title}
                  subTitle={EmptyStateForCilentOrg.subTitle}
                  title1={EmptyStateForCilentOrg.title1}
                  subTitle1={EmptyStateForCilentOrg.subTitle1}
                  subTitle2={EmptyStateForCilentOrg.subTitle2}
                  subTitle3={EmptyStateForCilentOrg.subTitle3}
                  create={EmptyStateForCilentOrg.create}
                  onClick={() => {
                    navigate(`/account/create-organization`, {
                      state: {
                        clientOrganizations: true,
                        selectedOrgId: orgId,
                      },
                    });
                  }}
                  docsheader={EmptyStateForCilentOrg.docsheader}
                  docsSubheader={EmptyStateForCilentOrg.docsSubheader}
                  docsbutton={EmptyStateForCilentOrg.docsbutton}
                  docsbuttonOnclick={() => {
                    window.open(
                      "https://docs.roconpaas.io/home/create-organization/",
                      "_blank",
                    );
                  }}
                  liveHeader={EmptyStateForCilentOrg.liveHeader}
                  liveSubheader={EmptyStateForCilentOrg.liveSubheader}
                  liveButton={EmptyStateForCilentOrg.liveButton}
                  livebuttonOnclick={() => {
                    window.open(
                      "https://docs.roconpaas.io/home/create-organization/",
                      "_blank",
                    );
                  }}
                />
              )}
              {((cancel === true && daysAfterExpiry >= 2) ||
                daysAfterExpiry >= 2) && (
                <PlanExpiredCard org={selectedOrg} plan={basePlan} />
              )}
            </Grid2>
          ) : (
            <NewEmptyState
              header={NewEmptyStateForCilentOrg.header}
              subHeader={NewEmptyStateForCilentOrg.subHeader}
              icon={ClientOrgImage}
              title={
                <span>
                  Don’t Miss Out
                  <span style={{ color: "#135FC2" }}> Activate </span>
                  Your Plan Now!
                </span>
              }
              subTitle={NewEmptyStateForCilentOrg.subTitle}
            />
          )}
        </>
      ) : (
        <PageLoading />
      )}
      <FormPopup
        trigger={popup.popupState}
        setTrigger={setPopup}
        type={popup.popupType}
        title={popup.popupTitle}
        subtitle={popup.popupSubtitle}
        button={popup.popupButton}
        cancel={popup.popupCancel}
        buttonTitle={popup.popupButtonTitle}
        buttonFunction={popup.popupButtonFunction}
        cancelTitle={popup.popupCancelTitle}
        cancelFunction={popup.popupCancelFunction}
      />
    </>
  );
}

export default ClientOrganizations;
